import React from "react";
import { Pencil } from "lucide-react";

/** Recap card used on the final review step — Heetch Pro dark */
export function SectionCard({ title, icon: Icon, onEdit, rows }) {
  return (
    <div className="hp-card overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 bg-[var(--surface-alt)] border-b border-[var(--border-soft)]">
        <div className="flex items-center gap-2">
          {Icon && <Icon className="w-4 h-4 text-emerald-400" strokeWidth={1.8} />}
          <span className="hp-label" style={{ color: "#86efac" }}>{title}</span>
        </div>
        <button
          onClick={onEdit}
          className="text-[11px] font-semibold text-emerald-400 hover:text-emerald-300 flex items-center gap-1 transition-colors"
        >
          <Pencil className="w-3 h-3" /> Modifier
        </button>
      </div>
      <div className="px-4 py-3 space-y-1.5">
        {rows.filter((l) => l?.value).map((l, i) => (
          <div key={i} className="flex gap-2 items-start">
            <span className="text-[11px] text-zinc-500 w-24 shrink-0 pt-0.5 uppercase tracking-wider">{l.label}</span>
            <span className="text-[13px] font-medium text-[var(--text)] flex-1 leading-snug">{l.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
